// extracted by mini-css-extract-plugin
export var clearIcon = "Search-module--clearIcon--4773c";
export var hasQuery = "Search-module--hasQuery--cc9b1";
export var scrollArea = "Search-module--scrollArea--4ccf0";
export var scrollThumb = "Search-module--scrollThumb--7b1a8";
export var searchBox = "Search-module--searchBox--4e855";
export var searchInput = "Search-module--searchInput--21f40";
export var searchInputContainer = "Search-module--searchInputContainer--662a9";